export default function MenuButtonBgBlob ({ color = '#F22D31' }) {
  return (
    <svg clipRule="evenodd" fillRule="evenodd" strokeLinejoin="round" strokeMiterlimit="2" version="1.1" viewBox="0 0 119 119" xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg">
      <g transform="matrix(1.8124 0 0 1.8124 -30.937 -52.588)">
        <path d="m82.239 89.661c-2.65 1.32-32.147 5.568-39.472 3.938-7.08-1.073-12.121-7.18-16.641-13.959-4.519-6.78-7.467-14.345-8.597-22.795-1.129-8.4-0.393-17.636 4.667-22.598 2.645-2.593 6.461-4.042 10.74-5.231h49.303v60.645z" fill={color} fillRule="nonzero"/>
      </g>
    </svg>
  )
}